import { createApp } from "vue";
import App from "./App.vue";
import PrimeVue from "primevue/config";
import { MPPreset } from "./mp-preset";
import "./styles/_theme.scss";
import "./styles/global.scss";
import "primeicons/primeicons.css";
import 'floating-vue/dist/style.css'
import store from "./store/index";
import ProgressSpinner from 'primevue/progressspinner';
import Popover from "primevue/popover";
import Slider from "primevue/slider";
import RadioButton from "primevue/radiobutton";
import Button from "primevue/button";
import InputText from "primevue/inputtext";
import Textarea from "primevue/textarea";
import Password from "primevue/password";
import Card from 'primevue/card';
import router from "./router";
import ConfirmationService from "primevue/confirmationservice";
import ConfirmDialog from "primevue/confirmdialog";
import Dialog from "primevue/dialog";
import ToggleSwitch from 'primevue/toggleswitch';
import Splitter from "primevue/splitter";
import SplitterPanel from "primevue/splitterpanel";
import BadgeDirective from "primevue/badgedirective";
import Tabs from 'primevue/tabs';
import FocusTrap from 'primevue/focustrap';
import TabList from 'primevue/tablist';
import Tab from 'primevue/tab';
import TabPanels from 'primevue/tabpanels';
import TabPanel from 'primevue/tabpanel';
import Avatar from "primevue/avatar";
import Badge from "primevue/badge";
import Select from "primevue/select";
import ToastService from "primevue/toastservice";
import Checkbox from "primevue/checkbox";
import Message from "primevue/message";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import DatePicker from "primevue/datepicker";
import Menu from "primevue/menu";
import MultiSelect from "primevue/multiselect";
import TreeSelect from "primevue/treeselect";
import ToggleButton from "primevue/togglebutton";
import Toast from "primevue/toast";
import ProgressBar from "primevue/progressbar";
import FileUpload from "primevue/fileupload";
import Divider from "primevue/divider";
import ScrollPanel from "primevue/scrollpanel";
import Tag from 'primevue/tag';
import { Form } from '@primevue/forms';
import PortalVue from 'portal-vue';
import FloatingVue from 'floating-vue';
import Accordion from "primevue/accordion";
import AccordionPanel from 'primevue/accordionpanel';
import AccordionHeader from 'primevue/accordionheader';
import AccordionContent from 'primevue/accordioncontent';
import Breadcrumb from 'primevue/breadcrumb';
import Skeleton from "primevue/skeleton";



const app = createApp(App)
  .use(store)
  .use(router)
  .use(PrimeVue, {
    theme: {
      preset: MPPreset,
      options: {
        darkModeSelector: '.app-dark',
      }
    },
    ripple: true 
 });

app.component("Popover", Popover);
app.component("Slider", Slider);
app.component("RadioButton", RadioButton);
app.component("Button", Button);
app.component("InputText", InputText);
app.component("Textarea", Textarea);
app.component("Password", Password);
app.component("Card", Card);
app.use(ConfirmationService);
app.component("ConfirmDialog", ConfirmDialog);
app.component("Dialog", Dialog);
app.component("ToggleSwitch", ToggleSwitch);
app.component("Splitter", Splitter);
app.component("SplitterPanel", SplitterPanel);
app.directive("badge", BadgeDirective);
app.directive("focustrap", FocusTrap);
app.directive("forcefocus", () => {
  (el: HTMLElement) => el.focus()
})
app.component("ProgressSpinner", ProgressSpinner);
app.component("Tabs", Tabs);
app.component("TabList", TabList);
app.component("Tab", Tab);
app.component("TabPanels", TabPanels);
app.component("TabPanel", TabPanel);
app.component("Avatar", Avatar);
app.component("Badge", Badge);
app.component("Select", Select);
app.component("Checkbox", Checkbox);
app.component("Message", Message);
app.component("DataTable", DataTable);
app.component("Column", Column);
app.component("DatePicker", DatePicker);
app.component("Menu", Menu);
app.component("MultiSelect", MultiSelect);
app.component("TreeSelect", TreeSelect);
app.component("ToggleButton", ToggleButton);
app.component("Toast", Toast);
app.component("ProgressBar", ProgressBar);
app.component("FileUpload", FileUpload);
app.component("Divider", Divider);
app.component("ScrollPanel", ScrollPanel);
app.component("Tag", Tag);
app.component("Form", Form);
app.component("Accordion", Accordion);
app.component("AccordionPanel", AccordionPanel);
app.component("AccordionHeader", AccordionHeader);
app.component("AccordionContent", AccordionContent);
app.component("Breadcrumb", Breadcrumb);

app.use(ToastService);
app.use(PortalVue);
app.use(FloatingVue);

app.mount("#app");

// Always apply dark mode class regardless of system preference (using this dummy CSS class)
document.documentElement.classList.add('app-dark')
